export enum Role {
  ROLE_ADMIN = 'ROLE_ADMIN',

  ROLE_SUPPLIERADMIN = 'ROLE_SUPPLIERADMIN',

  ROLE_EMPLOYEE = 'ROLE_EMPLOYEE',

  ROLE_CUSTOMER = 'ROLE_CUSTOMER',
}
